import script from "./Users.vue?vue&type=script&setup=true&lang=js"
export * from "./Users.vue?vue&type=script&setup=true&lang=js"

import "./Users.vue?vue&type=style&index=0&id=24203888&lang=css"

const __exports__ = script;

export default __exports__